import { render, staticRenderFns } from "./HsabExpenseCardRowInsuranceClaim.vue?vue&type=template&id=0a2fae08&scoped=true"
import script from "./HsabExpenseCardRowInsuranceClaim.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowInsuranceClaim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fae08",
  null
  
)

export default component.exports